import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 54 54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54 54\" id=\"icon-add\"><title>图标SVG-添加</title><path d=\"M38.09,25.07H28.93V15.91a.49.49,0,0,0-.48-.48h-2.9a.49.49,0,0,0-.48.48v9.16H15.91a.49.49,0,0,0-.48.48v2.9a.49.49,0,0,0,.48.48h9.16v9.16a.49.49,0,0,0,.48.48h2.9a.49.49,0,0,0,.48-.48V28.93h9.16a.49.49,0,0,0,.48-.48v-2.9a.49.49,0,0,0-.48-.48Zm0,0\" /><path d=\"M27,0A27,27,0,1,0,54,27,27,27,0,0,0,27,0Zm0,49.42A22.42,22.42,0,1,1,49.42,27,22.42,22.42,0,0,1,27,49.42Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol